
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { FrequencyType } from "@/models/base";
import { FrequencyDocumentEditState } from "../../utils/frequency-document-edit-state";
import AppSaleTypeSelect from "../sales/SaleTypeSelect.vue";
import AppSettingsMonthly from "../frequency/FrequencySettingsMonthly.vue";
import AppSettingsMonthlyPerWeek from "../frequency/FrequencySettingsMonthlyPerWeek.vue";
import AppSettingsWeekly from "../frequency/FrequencySettingsWeekly.vue";
import AppSettingsYearly from "../frequency/FrequencySettingsYearly.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	computed: {
		tabs(): string[] {
			return [
				this.$ct("weekly").toString(),
				this.$ct("monthly").toString(),
				this.$ct("monthly-per-week").toString(),
				this.$ct("yearly").toString(),
			];
		},
		tabSelectItems():ISelectItem<number>[] {
			return this.tabs.map((t, i) => {
				return {
					text: t,
					value: i
				} as ISelectItem<number>;
			});
		},
		selectedTab(): number {
			return this.state.doc.FrequencyType - 1;
		},
		hasEndDate(): boolean {
			return this.state.doc.EndDate != null;
		},
		isWeekly():boolean {
			return this.state.doc.FrequencyType == FrequencyType.Weekly;
		},
		isMonthly():boolean {
			return this.state.doc.FrequencyType == FrequencyType.Monthly;
		},
		isMonthlyPerWeek():boolean {
			return this.state.doc.FrequencyType == FrequencyType.MonthlyPerWeek;
		},
		isYearly():boolean {
			return this.state.doc.FrequencyType == FrequencyType.Yearly;
		},
		intervalLabel():string {
			if (this.isWeekly) {
				return "interval-label-weekly";
			}
			if (this.isYearly) {
				return "interval-label-yearly";
			}
			return "interval-label-monthly";
		}
	},
	methods: {
		toggleEndDate(value: boolean) {
			if (value) {
				this.state.doc.EndDate = new Date();
				this.state.doc.EndDate.setFullYear(this.state.doc.EndDate.getFullYear() + 1);
			} else {
				this.state.doc.EndDate = null;
			}
		},
		setSaleType(saleTypeId:number){
			this.state.doc.SaleTypeID = saleTypeId;
			this.state.setToPrintMessage(true);
		}
	},
	components: {
		AppSaleTypeSelect,
		AppSettingsWeekly,
		AppSettingsMonthly,
		AppSettingsMonthlyPerWeek,
		AppSettingsYearly
	},
	i18nEx: {
		componentPrefix: "components.frequency-documents"
	}
});
